import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { LocalStorageService, RepseService, ClientDocument } from '../../../services';
import { ContractRepseView } from '../../views';

class ContractRepseAction extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: {},
      token: '',
      loadingView: false,
      isNewContract: true,
      showErrorRequesting: false,
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      messageError: '',
      titleView: '',
      contract: {},
      proveedorRepse: {},
      documents: [],
      nameProveedor: '',
      company: '',
      selectedFile: null,
      selectedFileName: '',
      errorFile: false,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
      selectedContractor:{}
    }
  }

  token = {};
  user = {}
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  repseService = new RepseService(this.url)
  clientDocument = new ClientDocument(this.url);
  componentDidMount() {
    this.toggleLoadingRequesting(true)
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    let selectedContractor = this.props.selectedContractor
    let isNewContract = (this.props.contract && this.props.contract.id) ? false : true
    let titleView = (isNewContract) ? this.props.t("contractRepseView.title.new") : this.props.t("contractRepseView.title.edit")
    let company = this.props.company
    let proveedorRepse = this.props.proveedorRepse

    this.getDocumentsContrat(isNewContract)
    if (isNewContract === false) {
      this.getContractInfo()
    }

    this.setState({
      user: this.user,
      toke: this.token,
      isNewContract,
      titleView,
      company,
      proveedorRepse,
      selectedContractor
    })
    this.toggleLoadingView(false)
  }

  toggleLoadingView = (value) => {
    this.setState({
      loadingView: value
    })
  }

  toggleErrorRequesting = (message, time, sendInbox) => {
    this.setState({
      showErrorRequesting: true,
      messageError: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showErrorRequesting: false,
        })
        if (sendInbox) {
          this.props.history.push("/");
        }
      }, time || 4000)
    })
  }


  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };


  toggleCompletedRequesting = (time, sendPage, page) => {
    this.setState({
      showCompletedRequesting: true,
    }, () => {
      setTimeout(() => {
        this.setState({
          showCompletedRequesting: false,
        })
        if (sendPage) {
          this.props.history.push(page);
        }
      }, time || 4000)
    });
  }

  getContractInfo = () => {
    let contract = this.props.contract
    this.setState({
      contract
    })
  }

  handleCreateUpdateContract = async (contract) => {
    let errorMessage = 'Ocurrió un error al crear el contrato'
    let name = contract.name
    let reference = contract.reference
    let startDate = contract.startDate
    let endDate = contract.endDate
    let companyId = contract.companyId
    let contractorId = contract.contractorId
    let contractReason = contract.contractReason
    let vaultId = contract.vaultId
    let id = contract.id
    let paths = contract.paths

    try {
      let contractRepse = await this.repseService.createUpdateContractRepse(id, name, reference, startDate, endDate, companyId, contractorId, contractReason, vaultId, paths, this.token)
      if (contractRepse && contractRepse.data && Number(contractRepse.statusCode) === 200) {
        this.toggleLoadingRequesting(false)
        this.toggleCompletedRequesting(4000, false, '')
        setTimeout(() =>{
          this.props.toggleContractDetailsScreen(true)
          this.props.onContractorSelected(this.props.selectedContractor)
          this.props.toggleContractDetailsScreen(false)
        },[4000])
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(errorMessage, 4000, false)
      }
    } catch (error) {

      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(errorMessage, 4000, false)
    }
  }

  handleUploadContract = (contract) => {
    console.log('Actualizar contrato', contract)
  }

  handleFile = async (e) => {
    this.setState({
      selectedFile: e.target.files[0],
      selectedFileName: e.target.files[0].name,
      errorFile: false,
      colorBorderContainer: "green",
    });

    // Upload the base64 in the state
    let fileBase64 = await this.pdfToBase64(e.target.files[0]);
    let pdfBase64 = fileBase64.split(",")[1];
    this.setState({ selectedFileBase64: pdfBase64 });
  };

  pdfToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  handleDeleteFile = (e) => {
    this.setState({
      selectedFile: null,
      errorFile: false,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
    });
    return true;
  };

  getDocumentsContrat = async (isNewContract) => {
    let errorMessage = 'Ocurrió un error al obtener los documentos'
    let repseContractId = (isNewContract === false && this.props.contract && this.props.contract.id) ? this.props.contract.id : 0
    try {
      let documents = await this.repseService.getRepseContractDocuments(repseContractId, this.token)
      if (documents && documents.data && Number(documents.statusCode) === 200) {
        documents.data.map((doc) => {
          doc.name = (doc.clientDocumentTypeRequest.id === 2) ? `${doc.name} *` : doc.name
          let dateUpload = (doc.uploadedDate) ? `Cargado el ${doc.uploadedDate}` : 'Pendiente'
          doc.uploaded = (doc.docWasLoaded) ? dateUpload : 'Pendiente'
          doc.pathToSearch = doc.documentPath
          return doc
        })

        this.setState({
          documents: documents.data
        })
        this.toggleLoadingRequesting(false)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(errorMessage, 4000, false)
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(errorMessage, 4000, false)
    }
  }

  deleteRepseContract = async (id) => {
    this.toggleLoadingRequesting(true)
    let errorMessage = 'Ocurrió un error al eliminar los documentos'
    try {
      let repseContract = await this.repseService.deleteRepseContract(id, this.token)
      if (repseContract && repseContract.data && Number(repseContract.statusCode) === 200) {
        this.toggleLoadingRequesting(false)
        this.toggleCompletedRequesting(true)
      } else if (repseContract && repseContract.data && Number(repseContract.statusCode) === -5) {
        errorMessage = 'No se puede eliminar el contrato por que tiene documentos asignados'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(errorMessage, 4000, false)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(errorMessage, 4000, false)
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(errorMessage, 4000, false)
    }
  }

  handleUploadDocument = async (file, documentContract, setShowAws, setUrlPdf) => {
    let errorMessage = 'Ocurrió un error al cargar los documentos'

    try {
      let repseContractDocument = await this.repseService.uploadRepseContractDocument(documentContract, this.token)
      if (repseContractDocument && repseContractDocument.data && Number(repseContractDocument.statusCode) === 200) {
        this.toggleLoadingRequesting(false)
        this.handleFile(file)
        let docUploaded = this.state.documents.map((doc) => {
          if(doc.documentId === repseContractDocument.data.documentId){
            doc.pathToSearch = repseContractDocument.data.documentPath
            doc.path = repseContractDocument.data.pathToShow
            doc.uploaded =  `Cargado el ${repseContractDocument.data.dateToShow}`
            doc.docWasLoaded =  true
          }
          return doc
        })
        this.setState({
          documents: docUploaded
        })
        if(this.state.isNewContract){
          setUrlPdf(repseContractDocument.data.pathToShow)
        }
        this.toggleCompletedRequesting(true)
        setShowAws(false)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(errorMessage, 4000, false)
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(errorMessage, 4000, false)
    }
  }

  render() {
    return (
      <ContractRepseView
        {...this.state}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleLoadingView={this.toggleLoadingView}
        handleCreateUpdateContract={this.handleCreateUpdateContract}
        handleFile={this.handleDeleteFile}
        handleDeleteFile={this.handleDeleteFile}
        handleUploadDocument={this.handleUploadDocument}
        deleteRepseContract={this.deleteRepseContract}
        toggleContractDetailsScreen = {this.props.toggleContractDetailsScreen}
        onContractorSelected = {this.props.onContractorSelected}
      />
    )
  }
}


export default withTranslation()(ContractRepseAction)